import type React from 'react'

export const affiliateCardShell: React.CSSProperties = {
  borderRadius: 20,
  border: '1px solid rgba(90, 161, 255, 0.28)',
  background: 'linear-gradient(135deg, rgba(8,17,53,0.95), rgba(17,52,104,0.82))',
  boxShadow: '0 18px 45px rgba(8, 16, 48, 0.28)',
}

export const affiliateMutedText = '#dbeafe'
export const affiliateSubtleText = '#bfd3ff'

export function affiliateTopRankClass(index: number): string {
  if (index === 0) return 'affiliate-member-card__rank affiliate-member-card__rank--gold'
  if (index === 1) return 'affiliate-member-card__rank affiliate-member-card__rank--silver'
  if (index === 2) return 'affiliate-member-card__rank affiliate-member-card__rank--bronze'
  return 'affiliate-member-card__rank'
}
